export const SERVER_NAME = "https://api.radiodiagnostics.services";
// export const SERVER_NAME = "http://localhost:8000";
// export const SERVER_NAME = "https://api.radiodiagnostics.services";

